import React from "react";
import { Link } from "react-router-dom";

export default class Footer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <footer id="footer">
        Heide Janowitz |&nbsp;<Link to="/impressum">Impressum</Link>
      </footer>
    );
  }
}
